import cx from "classnames";

import styles from "./styles.module.scss";

const Button = (props) => {
  const {
    label,
    onClick,
    disabled = false,
    className,
    buttonVariant,
    startIcon,
    endIcon,
    ...restProps
  } = props;

  const buttonTypeClassName = styles[buttonVariant];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cx(
        styles.button,
        buttonTypeClassName,
        disabled && styles.disabled,
        className,
      )}
      {...restProps}
    >
      {startIcon && <span className={styles.icon}>{startIcon}</span>}

      <span className={styles.label}>{label}</span>

      {endIcon && <span className={styles.icon}>{endIcon}</span>}
    </button>
  );
};

export default Button;
